// removed by extract-text-webpack-plugin
module.exports = {"mediaContainer":"_375ce","background_color":"_1MoVp","inline":"_37yb_","infoContainer":"_2WllT","mcTitle":"TS4b6","mcInfo":"_3zXdY","mcDescription":"_15s7G","playerContainer":"_2WPC7","player":"_3FZZJ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Featured/style.scss
// module id = VJcM
// module chunks = 0